"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const isInternalURL = (url) => {
  const isInternal = /^(\/(?!\/)|#)/.test(url);
  const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};
exports.isInternalURL = isInternalURL;
//# sourceMappingURL=isInternalURL.cjs.map
